var map = {
	"./Vorschaubild_1.jpg": "fe6e",
	"./Vorschaubild_2.jpg": "2e13",
	"./Vorschaubild_3.jpg": "bf7f",
	"./Vorschaubild_4.jpg": "55fd",
	"./Vorschaubild_5.jpg": "425d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b5a";